import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import ConfirmationDialog from "../../../../../components/dialogs/ConfirmationDialog";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../icons/iconExport";

const DeleteLabelMenu = ({ label, onDeleteLabel, deleteLabelMutation }) => {
  const colors = useColors();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const { trackEvent } = useAPI();

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    trackEvent("User clicked on delete label menu");
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleDeleteClick = () => {
    trackEvent("User clicked on delete label");
    setShowConfirmDialog(true);
    handleMenuClose();
  };

  const handleConfirmDelete = () => {
    trackEvent("User confirmed to delete label " + label.name);
    onDeleteLabel(label.label_id);
    setShowConfirmDialog(false);
  };

  const handleCancelDelete = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <IconButton
        onClick={handleMenuOpen}
        IconSVG={icons.MenuVerticalIcon}
        sx={{
          width: "24px",
          height: "24px",
          "&:hover": {
            backgroundColor: colors.grey_100,
          },
        }}
      >
        <SvgToIcon
          IconLogo={icons.MenuVerticalIcon}
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            minWidth: "120px",
            border: colors.grey_200,
            boxShadow: "0px 1px 4px 0px " + colors.grey_500,
          },
          "& .MuiList-root": {
            padding: "4px",
          },
          marginLeft: "16px",
        }}
      >
        <MenuItem
          onClick={handleDeleteClick}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "8px 12px",
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: colors.grey_4percent,
            },
          }}
        >
          <SvgToIcon
            IconLogo={icons.DeleteBinIcon2}
            style={{
              width: "18px",
              height: "18px",
            }}
          />
          <Typography
            variant="caption"
            sx={{
              color: colors.text_secondary,
            }}
          >
            Delete
          </Typography>
        </MenuItem>
      </Menu>
      <ConfirmationDialog
        openDialog={showConfirmDialog}
        handleDialogClose={handleCancelDelete}
        handleConfirm={handleConfirmDelete}
        dialogTitle="Delete Label?"
        dialogContentFirstLine={`Deleting the label "${label.name}" will remove it from all entities.`}
        confirmationButtonText="Delete"
        cancelButtonText="Cancel"
        destructive={true}
        isLoading={deleteLabelMutation.isPending}
        isLoadingText="Deleting..."
      />
    </>
  );
};

export default DeleteLabelMenu;
